export const helpContentLeaderboardsStygian = (
  <>
    <div className="help-box-header">
      <b>Stygian</b> leaderboards
    </div>
    <div className="help-box-p">
      <b>
        Do not use Akasha's suspicious clear flag to witchhunt people as legit
        scores can be flagged in rare cases
      </b>
      .
    </div>
    <div className="help-box-p">
      Dire clears go through very basic anti-cheat filtering tailored to each
      game version, <b>it is not perfect</b>.
    </div>
    <div className="help-box-p">
      <div>
        Clears will be marked as suspicious based on characters and weapons you
        have displayed on your Akasha profile.
      </div>
    </div>
    <div className="help-box-p">
      <div>
        Dire clears with private showcases are flagged automatically - in order
        to participate you need to have at least <b>two characters</b> on your
        profile.
      </div>
    </div>
  </>
);
